import { THORCHAIN_ROUTER_ABI } from '@shapeshiftoss/contracts';
import { encodeFunctionData } from 'viem';
export const depositWithExpiry = ({ vault, asset, amount, memo, expiry, }) => {
    const data = encodeFunctionData({
        abi: THORCHAIN_ROUTER_ABI,
        functionName: 'depositWithExpiry',
        args: [vault, asset, amount, memo, expiry],
    });
    return data;
};
